// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__YahEa","unreadBadge":"styles_unreadBadge__2KxEG","modalContent":"styles_modalContent__vrsBe","modal":"styles_modal__3nXbC"};